import { parseFilters } from "../../../../../helpers/url.js";
import { BORG_ENDPOINT } from "../utils/autocomplete.js";
export const getSuggestions = async (queryParams, BaseUrl, endpoint = BORG_ENDPOINT)=>{
    const { query , language , format ='json' , geolocation =false , n =20 , type =[] , o ='' , p =''  } = queryParams;
    let finalUrl = endpoint;
    if (!endpoint.startsWith('http')) finalUrl = `${BaseUrl}${endpoint}`;
    const filters = {
        q: query,
        l: language,
        f: format,
        g: `${geolocation}`,
        n: n.toString(),
        t: type.join(','),
        o,
        p
    };
    const url = `${finalUrl}?${parseFilters(filters)}`;
    const response = await fetch(url, {
        cache: 'no-store'
    });
    if (!response.ok || response.status !== 200 && response.status !== 204) throw new Error(response.statusText);
    return response.json().catch(()=>({
            d: []
        }));
};

//# sourceMappingURL=index.js.map